import { Marker } from "@react-google-maps/api";
/* global grecaptcha */
import React, { useEffect, useState } from "react";
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import "../style/Contact.css";
import emailjs from "emailjs-com";
import { useMediaQuery } from "react-responsive";
import { useRef } from "react";
// import { useMediaQuery } from "react-responsive";

// const darkModeStyles = [
//   { elementType: "geometry", stylers: [{ color: "#212121" }] },
//   { elementType: "labels.icon", stylers: [{ visibility: "on" }] },
//   { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
//   { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
//   {
//     featureType: "administrative",
//     elementType: "geometry",
//     stylers: [{ color: "#757575" }],
//   },
//   {
//     featureType: "administrative.country",
//     elementType: "labels.text.fill",
//     stylers: [{ color: "#9e9e9e" }],
//   },
//   {
//     featureType: "administrative.land_parcel",
//     stylers: [{ visibility: "off" }],
//   },
//   {
//     featureType: "administrative.locality",
//     elementType: "labels.text.fill",
//     stylers: [{ color: "#bdbdbd" }],
//   },
//   {
//     featureType: "poi",
//     elementType: "labels.text.fill",
//     stylers: [{ color: "#757575" }],
//   },
//   {
//     featureType: "poi.park",
//     elementType: "geometry",
//     stylers: [{ color: "#181818" }],
//   },
//   {
//     featureType: "poi.park",
//     elementType: "labels.text.fill",
//     stylers: [{ color: "#616161" }],
//   },
//   {
//     featureType: "poi.park",
//     elementType: "labels.text.stroke",
//     stylers: [{ color: "#1b1b1b" }],
//   },
//   {
//     featureType: "road",
//     elementType: "geometry.fill",
//     stylers: [{ color: "#2c2c2c" }],
//   },
//   {
//     featureType: "road",
//     elementType: "labels.text.fill",
//     stylers: [{ color: "#8a8a8a" }],
//   },
//   {
//     featureType: "road.arterial",
//     elementType: "geometry",
//     stylers: [{ color: "#373737" }],
//   },
//   {
//     featureType: "road.highway",
//     elementType: "geometry",
//     stylers: [{ color: "#ffff00" }],
//   },
//   {
//     featureType: "road.highway.controlled_access",
//     elementType: "geometry",
//     stylers: [{ color: "#ffff00" }],
//   },
//   {
//     featureType: "road.local",
//     elementType: "labels.text.fill",
//     stylers: [{ color: "#616161" }],
//   },
//   {
//     featureType: "transit",
//     elementType: "labels.text.fill",
//     stylers: [{ color: "#757575" }],
//   },
//   {
//     featureType: "water",
//     elementType: "geometry",
//     stylers: [{ color: "#000000" }],
//   },
//   {
//     featureType: "water",
//     elementType: "labels.text.fill",
//     stylers: [{ color: "#3d3d3d" }],
//   },
// ];

const mapStyles = {
  height: "100%",
  width: "100%",
};

const defaultCenter = {
  lat: 33.26919885111055,
  lng: 35.19960687855066,
};

const beirutCenter = {
  lat: 33.89496903557062,
  lng: 35.49454679936923,
};

const lebanonCenter = {
  lat: 33.88566120407516,
  lng: 35.491241455078125,
};

const getTodayDateTime = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const hours = String(today.getHours()).padStart(2, "0");
  const minutes = String(today.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const roundToNearest15Minutes = (date) => {
  const ms = 1000 * 60 * 15; // convert 15 minutes to milliseconds
  const roundedDate = new Date(Math.round(date.getTime() / ms) * ms);

  // Adjust to local timezone
  const offset = date.getTimezoneOffset() * 60000; // offset in milliseconds
  return new Date(roundedDate.getTime() - offset);
};

const cityClinicMap = {
  Beirut: ["Phoenicia Clinic - Beirut"],
  Tyre: ["Phoenicia Clinic - Tyre"],
};

// For multiple clinics :
// const cityClinicEmail = {
//   Beirut: ["Advanced Dental Clinic"],
//   Tyre: ["Advanced Dental Clinic"],
// };

const ContactUs = () => {
  // Set minDate using useEffect to avoid calling it every render
  const [minDate, setMinDate] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    number: "",
    date: "",
    city: "",
    clinic: "",
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [clinics, setClinics] = useState([]);
  const mapRef = useRef(null);

  useEffect(() => {
    // Update clinics dropdown when city changes
    if (formData.city) {
      setClinics(cityClinicMap[formData.city]);
      setFormData((prev) => ({ ...prev, clinic: "" })); // reset clinic when city changes

      if (mapRef.current) {
        const newCenter =
          formData.city === "Beirut" ? beirutCenter : defaultCenter;
        mapRef.current.panTo(newCenter);
        mapRef.current.setZoom(14);
      }
    } else {
      setClinics([]);
      setFormData((prev) => ({ ...prev, clinic: "" }));
      if (mapRef.current) {
        mapRef.current.panTo(lebanonCenter);
        mapRef.current.setZoom(9);
      }
    }
  }, [formData.city]);

  const handleClick = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    if (
      formData.name === "" ||
      formData.number === "" ||
      formData.date === "" ||
      formData.city === "" ||
      formData.clinic === ""
    ) {
      alert("Please fill in all required fields.");
      return;
    }
    handleSubmit(e);
    setIsDisabled(true);
    setFormData({
      name: "",
      number: "",
      date: "",
      city: "",
      clinic: "",
    });
    setTimeout(() => {
      setIsDisabled(false);
    }, 10000);
  };
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  useEffect(() => {
    loadRecaptcha();
    setMinDate(getTodayDateTime());
  }, []);

  const handleKeyDown = (event) => {
    if (
      event.key === "e" ||
      event.key === "E" ||
      event.key === "+" ||
      event.key === "-" ||
      event.key === "."
    ) {
      event.preventDefault();
    }
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "number") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else if (name === "date") {
      const date = new Date(value);
      const roundedDate = roundToNearest15Minutes(date);
      setFormData({
        ...formData,
        [name]: roundedDate.toISOString().slice(0, 16), // Format the date to 'YYYY-MM-DDTHH:MM'
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(false);
    await loadRecaptcha();
    const token = await grecaptcha.enterprise.execute(
      "6Lcq_CsqAAAAAEko6Lgg1q8RWYhqiqXUtDrwJzD9",
      { action: "SUBMIT_FORM" }
    );

    if (!token) {
      alert("Failed to get reCAPTCHA token. Please try again.");
      return;
    }

    const templateParams = {
      name: formData.name,
      number: formData.number,
      date: formData.date.replace("T", " "),
      city: formData.city,
      clinic: formData.clinic,
      to_email: "lamaanaligners@gmail.com",
    };

    try {
      const response = await fetch(
        "https://recaptcha.healthflowonline.com/node/verify-recaptcha/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token, recaptchaAction: "SUBMIT_FORM" }),
        }
      );

      const result = await response.json();
      if (result.success) {
        emailjs
          .send(
            "service_o9g42fl", // Replace with your EmailJS service ID
            "template_dta689g", // Replace with your EmailJS template ID
            templateParams,
            "kOdM1I8wHJsCHw4Dl" // Replace with your EmailJS user ID (public key)
          )
          .then(
            (response) => {
              console.log("SUCCESS!", response.status, response.text);
              alert("Form submitted successfully!");
            },
            (err) => {
              console.log("FAILED...", err);
              alert("Form submission failed. Please try again.");
            }
          );
      } else {
        alert("reCAPTCHA verification failed. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying reCAPTCHA:", error);
      alert("Form submission failed. Please try again.");
    }
  };

  const markerIcon = {
    url: "https://maps.gstatic.com/mapfiles/ms2/micons/red-dot.png",
    labelOrigin: { x: 120, y: 10 },
  };

  return (
    <div className="contact-container" id="contact">
      <div className="map-container">
        <LoadScript googleMapsApiKey="AIzaSyBHPsmzNMENBbjNK4WFf9U1XqJLe4hxwNw">
          <GoogleMap
            mapContainerStyle={mapStyles}
            zoom={formData.city === "" ? 9 : 14}
            center={
              formData.city === "Beirut"
                ? beirutCenter
                : formData.city === ""
                ? lebanonCenter
                : defaultCenter
            }
            onLoad={(map) => (mapRef.current = map)}
            // options={{
            //   styles: darkModeStyles,
            // }}
          >
            {formData.city && formData.clinic && (
              <Marker
                position={
                  formData.city === "Beirut" ? beirutCenter : defaultCenter
                }
                clickable={true}
                title={cityClinicMap[formData.city][0]}
                label={{
                  text: cityClinicMap[formData.city][0],
                  color: "red",
                  fontSize: "1.7rem",
                  className: "map-pin-label",
                }}
                icon={markerIcon}
              />
            )}
          </GoogleMap>
        </LoadScript>
      </div>
      <div className="form-container">
        <h2 className="contact-title">Contact Us</h2>
        <h2>
          {/* Have Questions? */}
          {/* <br /> */}
          {/* How Can We Assist? */}
          Reserve an Appointment
        </h2>
        <form className="contact-form-container needs-validation" noValidate>
          <div className="form-group">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              required
              className={`input-placeholder ${
                isSubmitted && !formData.name ? "error" : ""
              }`}
              value={formData.name}
              onChange={handleChange}
            />
            {isSubmitted && !formData.name && (
              <div className="error-text">Required Field</div>
            )}
          </div>
          <div className="form-group">
            <input
              type="number"
              name="number"
              placeholder="Mobile"
              required
              className={`input-placeholder ${
                isSubmitted && !formData.number ? "error" : ""
              }`}
              value={formData.number}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />
            {isSubmitted && !formData.number && (
              <div className="error-text">Required Field</div>
            )}
          </div>
          {/* <div className="form-group">
            <input type="email" placeholder="Email Address" required />
            <input type="text" placeholder="Subject" required />
          </div> */}
          <div className="form-group dropdown-row">
            <select
              name="city"
              required
              className={`input-placeholder city-dropdown ${
                isSubmitted && !formData.city ? "error" : ""
              }`}
              value={formData.city}
              onChange={handleChange}
            >
              <option value="">City</option>
              {Object.keys(cityClinicMap).map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </select>
            {isSubmitted && !formData.city && (
              <div className="error-text">Required Field</div>
            )}
            <select
              name="clinic"
              required
              className={`input-placeholder clinic-dropdown ${
                isSubmitted && !formData.clinic ? "error" : ""
              }`}
              value={formData.clinic}
              onChange={handleChange}
            >
              <option value="">Clinic</option>
              {clinics.map((clinic) => (
                <option key={clinic} value={clinic}>
                  {clinic}
                </option>
              ))}
            </select>
            {isSubmitted && !formData.clinic && (
              <div className="error-text">Required Field</div>
            )}
          </div>
          <div className="form-group">
            {/* <textarea placeholder="Your Message" required></textarea> */}
            <div
              style={{
                width: "100%",
              }}
            >
              {isMobile && (
                <label
                  htmlFor="date"
                  className="contact-label"
                  style={{
                    fontSize: "2rem",
                    color: "#B6BCC5",
                    marginLeft: "2rem",
                  }}
                >
                  Calendar
                </label>
              )}
              <input
                type="datetime-local"
                name="date"
                className={`contact-datetime ${
                  isSubmitted && !formData.date ? "error" : ""
                }`}
                required
                value={formData.date}
                onChange={handleChange}
                min={minDate}
                style={{ width: "100%", boxSizing: "border-box" }}
              />
            </div>
            {isSubmitted && !formData.date && (
              <div className="error-text">Required Field</div>
            )}{" "}
          </div>

          <button
            type="submit"
            className="contact-link-btn"
            onClick={handleClick}
            disabled={isDisabled}
            style={{
              display: "flex",
              margin: "0 auto",
            }}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;

const loadRecaptcha = () => {
  return new Promise((resolve) => {
    if (document.getElementById("recaptcha-script")) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.id = "recaptcha-script";
    script.src =
      "https://www.google.com/recaptcha/enterprise.js?render=6Lcq_CsqAAAAAEko6Lgg1q8RWYhqiqXUtDrwJzD9";
    script.onload = resolve;
    document.body.appendChild(script);
  });
};
